import "./Profile.css";
import UserProfile from "./components/UserProfile.jsx";
import { Tab } from "@headlessui/react";
import UltimosModelosCreados from "./components/UltimosModelosCreados/UltimosModelosCreados.jsx";
import ListasDirecciones from "./components/ListaDirecciones/ListasDirecciones.jsx";
import Editor from "./components/Editor/Editor.jsx";

import {

    Fragment,
    useState,
    useEffect,
    createContext,
    useContext
} from "react";

import React from "react";

import { AnimatePresence, motion } from "framer-motion";
import ListaModelosLlaveros from "./pages/Modelos/ListaModelosLlaveros.jsx";
import ListaMedios from "./pages/Medios/ListaMedios.jsx";
import ListaClientes from "../Admin/pages/Clientes/ListaClientes.jsx";
import { useEditor } from "../../App.jsx";
import { useAuthContext } from "../../components/providers/AuthProvider.jsx";
import MisProyectos from "./pages/MisProyectos/MisProyectos.jsx";
import AdminPanelProductos from "../Store/AdminPanelProductos.jsx";

import {
    Home,
    Box,
    Camera,
    ShoppingCart,
    Users,
    Package,
    BriefcaseBusiness,
    Menu
} from "lucide-react";
import useMediaQuery from "../../components/tools/useMediaQuery.jsx";
import ListaModelosLlaverosTodosAdmin from "./pages/Modelos/ListaModelosLlaverosTodosAdmin.jsx";
import EnlacesPublicosAdmin from "./pages/Admin/EnlacesPublicos/EnlacesPublicosAdmin.jsx";

/*************** Context Cliente *****************/
const ClienteContext = createContext();
const ClienteProvider = ({ children }) => {
    const [cliente, setCliente] = useState();
    return (
        <ClienteContext.Provider value={{ cliente, setCliente }}>
            {children}
        </ClienteContext.Provider>
    );
};
export const useCliente = () => useContext(ClienteContext);
/*************** Fin Context Cliente *************/

/*************** Context Proyecto *****************/
const ProyectoContext = createContext();
const ProyectoProvider = ({ children }) => {
    const [proyecto, setProyecto] = useState();
    return (
        <ProyectoContext.Provider value={{ proyecto, setProyecto }}>
            {children}
        </ProyectoContext.Provider>
    );
};
export const useProyecto = () => useContext(ProyectoContext);
/*************** Fin Context Proyecto *************/

/*************** Context Presupuesto *************/
const PresupuestoContext = createContext();
const PresupuestoProvider = ({ children }) => {
    const [presupuesto, setPresupuesto] = useState();
    return (
        <PresupuestoContext.Provider value={{ presupuesto, setPresupuesto }}>
            {children}
        </PresupuestoContext.Provider>
    );
};
export const usePresupuesto = () => useContext(PresupuestoContext);
/*************** Fin Context Presupuesto *********/

export const ProyectoEditorWrapper = ({
                                          id,
                                          setEditor,
                                          setEditorID,
                                          editorType,
                                          setEditorType
                                      }) => {
    return (
        <PresupuestoProvider>
            <ProyectoProvider>
                <ClienteProvider>
                    <Editor
                        id={id}
                        setEditor={setEditor}
                        setEditorID={setEditorID}
                        editorType={editorType}
                        setEditorType={setEditorType}
                    />
                </ClienteProvider>
            </ProyectoProvider>
        </PresupuestoProvider>
    );
};

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

function Profile() {
    const [editor, setEditor] = useState(false);
    const [editorType, setEditorType] = useState(null);
    const [editorID, setEditorID] = useState(null);

    const initialState = {
        editor: false,
        editorID: null,
        editorType: null,
        misproyectosindex: 0
    };

    const { stateEditor, setStateEditor } = useEditor();
    const [selectedIndex, setSelectedIndex] = useState(

        stateEditor?.misproyectosindex
    );

    useEffect(() => {
        // Ejemplo de cómo podrías guardar el índice
        // en un estado global si lo deseas
        // setStateEditor({
        //   ...stateEditor,
        //   misproyectosindex: selectedIndex
        // });
        console.log("misproyectosindex", stateEditor?.misproyectosindex);
    }, [stateEditor]);

    useEffect(() => {
        if (selectedIndex === -1) {
            setEditor(true);
        }
    }, [selectedIndex]);

    const authContext = useAuthContext();

    // **** Estado para abrir/cerrar menú móvil
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isDesktop = useMediaQuery("(min-width: 1024px)"); // 1024px ~ lg

    return (
        <div className="w-full h-full p-3 relative">
            <Tab.Group
                selectedIndex={selectedIndex}
                onChange={setSelectedIndex}
                className="h-full"
            >
                <div className="w-full h-full lg:w-9/12 mx-auto flex flex-col lg:flex-row gap-3 px-2 py-2 lg:py-0 ">
                    {/* Left Section */}
                    {!stateEditor?.editor && (
                        <div className="w-full lg:w-2/12 lg:min-h-full lg:h-full glassCard rounded-lg p-1 ">
                            {/* **** Botón de menú para pantallas pequeñas */}
                            <div className="flex items-center justify-between lg:hidden p-2">
                                <h2 className="font-bold text-xl">Menú</h2>
                                <button
                                    className="p-2 rounded hover:bg-secondary text-neutral"
                                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                                >
                                    <Menu className="w-5 h-5" />
                                </button>
                            </div>

                            {isDesktop && (
                                <div className="hidden lg:block">
                                    <TabListContent
                                        authContext={authContext}
                                        selectedIndex={selectedIndex}
                                    />
                                </div>
                            )}

                            {!isDesktop && (

                                <AnimatePresence>
                                    {isMenuOpen && (
                                        <motion.div
                                            key="mobile-menu"
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                            // style={{ overflow: "hidden" }}
                                            className="block lg:hidden p-2"
                                        >
                                            <TabListContent
                                                authContext={authContext}
                                                selectedIndex={selectedIndex}
                                                onClick={() => setIsMenuOpen(false)}
                                            />
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            )}
                        </div>
                    )}

                    {/* Right Section */}
                    <div
                        className={classNames(
                            // Ajusta la altura dependiendo de si está el editor o no
                            stateEditor?.editor ? "h-full" : "h-[87.5%]",
                            "w-full lg:ml-2 lg:h-full",
                            stateEditor?.editor ? "lg:w-full" : "lg:w-10/12"
                        )}
                    >
                        <AnimatePresence>
                            <div className={`min-h-full h-full`}>
                                {!stateEditor?.editor ? (
                                    <Tab.Panels className="h-full w-full">
                                        <Tab.Panel
                                            key={"general"}
                                            className="h-full max-h-full ring-white/60 ring-offset-2 ring-offset-blue-400"
                                        >
                                            <div className="min-h-full h-full max-h-full ">
                                                <div className="h-full max-h-full overflow-y-auto scrollbar_mod">
                                                    <UserProfile />
                                                    <UltimosModelosCreados />
                                                    {/*<ListasDirecciones
                                                        setEditor={setEditor}
                                                        setEditorType={setEditorType}
                                                        setEditorID={setEditorID}
                                                    />*/}
                                                </div>
                                            </div>
                                        </Tab.Panel>

                                        <Tab.Panel
                                            key={"modelos_creados"}
                                            className="h-full min-h-full ring-white/60 ring-offset-2 ring-offset-blue-400"
                                        >
                                            <ListaModelosLlaveros />
                                        </Tab.Panel>

                                        <Tab.Panel
                                            key={"medios"}
                                            className="h-full min-h-full ring-white/60 ring-offset-2 ring-offset-blue-400"
                                        >
                                            <ListaMedios
                                                setEditor={setEditor}
                                                setEditorType={setEditorType}
                                                setEditorID={setEditorID}
                                            />
                                        </Tab.Panel>

                                        <Tab.Panel
                                            key={"pedidos"}
                                            className="h-full ring-white/60 ring-offset-2 ring-offset-blue-400"
                                        >
                                            {/* Aquí puedes agregar el contenido de Pedidos */}
                                        </Tab.Panel>


                                        <Tab.Panel
                                            key={"proyectos"}
                                            className="h-full rounded-xl ring-white/60 ring-offset-2 ring-offset-blue-400"
                                        >
                                            <MisProyectos />
                                        </Tab.Panel>
                                        {authContext.role === "admin" && (
                                            <Tab.Panel
                                                key={"clientes"}
                                                className="h-full rounded-xl ring-white/60 ring-offset-2 ring-offset-blue-400"
                                            >
                                                <ListaClientes
                                                    setEditor={setEditor}
                                                    setEditorType={setEditorType}
                                                    setEditorID={setEditorID}
                                                />
                                            </Tab.Panel>
                                        )}

                                        {authContext.role === "admin" && (
                                            <Tab.Panel
                                                key={"productos"}
                                                className="h-full rounded-xl  ring-white/60 ring-offset-2 ring-offset-blue-400"
                                            >
                                                <AdminPanelProductos />
                                            </Tab.Panel>
                                        )}


                                        {authContext.role === "admin" && (
                                            <Tab.Panel
                                                key={"todos-modelos-creados"}
                                                className="h-full rounded-xl  ring-white/60 ring-offset-2 ring-offset-blue-400"
                                            >
                                                <ListaModelosLlaverosTodosAdmin />
                                            </Tab.Panel>
                                        )}
                                        {authContext.role === "admin" && (
                                            <Tab.Panel
                                                key={"enlaces_publicos"}
                                                className="h-full rounded-xl  ring-white/60 ring-offset-2 ring-offset-blue-400"
                                            >

                                                <EnlacesPublicosAdmin />
                                            </Tab.Panel>
                                        )}

                                    </Tab.Panels>
                                ) : (
                                    <ProyectoEditorWrapper
                                        setEditor={setEditor}
                                        editorType={editorType}
                                        id={editorID}
                                        setEditorID={setEditorID}
                                        setEditorType={setEditorType}
                                    />
                                )}
                            </div>
                        </AnimatePresence>
                    </div>
                </div>
            </Tab.Group>
        </div>
    );
}

// **** Para no repetir código, extraemos la lista de pestañas a un componente
function TabListContent({ authContext, onClick }) {
    return (
        <Tab.List className="flex flex-col space-y-2">
            <Tab
                key="general"
                className={({ selected }) =>
                    classNames(
                        "flex items-center p-3 rounded-lg transition-colors duration-200",
                        selected
                            ? "bg-neutral text-base-300 font-bold"
                            : "text-neutral hover:bg-secondary hover:text-white"
                    )
                }
                onClick={onClick}
            >
                <Home className="w-5 h-5 mr-3" />
                <span className="text-sm w-full">General</span>
            </Tab>

            <Tab
                key="modelos_creados"
                className={({ selected }) =>
                    classNames(
                        "flex items-center p-3 rounded-lg transition-colors duration-200",
                        selected
                            ? "bg-neutral text-base-300 font-bold"
                            : "text-neutral hover:bg-secondary hover:text-white"
                    )
                }
                onClick={onClick}
            >
                <Box className="w-5 h-5 mr-3" />
                <span className="text-sm w-full">Modelos creados</span>
            </Tab>

            <Tab
                key="medios"
                className={({ selected }) =>
                    classNames(
                        "flex items-center p-3 rounded-lg transition-colors duration-200",
                        selected
                            ? "bg-neutral text-base-300 font-bold"
                            : "text-neutral hover:bg-secondary hover:text-white"
                    )
                }
                onClick={onClick}
            >
                <Camera className="w-5 h-5 mr-3" />
                <span className="text-sm w-full">Medios</span>
            </Tab>

            <Tab
                key="pedidos"
                className={({ selected }) =>
                    classNames(
                        "flex items-center p-3 rounded-lg transition-colors duration-200",
                        selected
                            ? "bg-neutral text-base-300 font-bold"
                            : "text-neutral hover:bg-secondary hover:text-white"
                    )
                }
                onClick={onClick}
            >
                <ShoppingCart className="w-5 h-5 mr-3" />
                <span className="text-sm w-full">Pedidos</span>
            </Tab>

            <Tab
                key="proyectos"
                className={({ selected }) =>
                    classNames(
                        "flex items-center p-3 rounded-lg transition-colors duration-200",
                        selected
                            ? "bg-neutral text-base-300 font-bold"
                            : "text-neutral hover:bg-secondary hover:text-white"
                    )
                }
                onClick={onClick}
            >
                <BriefcaseBusiness className="w-5 h-5 mr-3" />
                <span className="text-sm w-full">Proyectos</span>
            </Tab>

            {authContext.role === "admin" && (
                <Tab
                    key="clientes"
                    className={({ selected }) =>
                        classNames(
                            "flex items-center p-3 rounded-lg transition-colors duration-200",
                            selected
                                ? "bg-neutral text-base-300 font-bold"
                                : "text-neutral hover:bg-secondary hover:text-white"
                        )
                    }
                    onClick={onClick}
                >
                    <Users className="w-5 h-5 mr-3" />
                    <span className="text-sm w-full">Clientes (Admin)</span>
                </Tab>
            )}

            {authContext.role === "admin" && (
                <Tab
                    key="productos"
                    className={({ selected }) =>
                        classNames(
                            "flex items-center p-3 rounded-lg transition-colors duration-200",
                            selected
                                ? "bg-neutral text-base-300 font-bold"
                                : "text-neutral hover:bg-secondary hover:text-white"
                        )
                    }
                    onClick={onClick}
                >
                    <Package className="w-5 h-5 mr-3" />
                    <span className="text-sm w-full">Productos (Admin)</span>
                </Tab>
            )}
            {authContext.role === "admin" && (
                <>

                    <Tab
                        key="todo_modelos_creados"
                        className={({ selected }) =>
                            classNames(
                                "flex items-center p-3 rounded-lg transition-colors duration-200",
                                selected
                                    ? "bg-neutral text-base-300 font-bold"
                                    : "text-neutral hover:bg-secondary hover:text-white"
                            )
                        }
                        onClick={onClick}
                    >
                        <Box className="w-5 h-5 mr-3" />
                        <span className="text-sm w-full">Modelos creados Todos (Admin)</span>
                    </Tab>

                    <Tab
                        key="enlaces_publicos"
                        className={({ selected }) =>
                            classNames(
                                "flex items-center p-3 rounded-lg transition-colors duration-200",
                                selected
                                    ? "bg-neutral text-base-300 font-bold"
                                    : "text-neutral hover:bg-secondary hover:text-white"
                            )
                        }
                        onClick={onClick}
                    >
                        <Box className="w-5 h-5 mr-3" />
                        <span className="text-sm w-full">Enlaces públicos (Admin)</span>
                    </Tab>
                </>
            )}

        </Tab.List>
    );
}

export default Profile;
